import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLabel } from '@platform/hooks/useLabel';
import { Icon } from '@platform/ui';
import { routes } from '@platform/core/lib/routes';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { useShellNav } from './useShellNav';
import type { IHelpButtonProps } from './IHelpButtonProps';
import { websiteUrl } from './websiteUrl';

/**
 * Довідка (UIUX top-bar: Help): у модулі — сторінка «Довідка» поточного модуля, поза модулем — довідковий центр на вебсайті (нова вкладка).
 * Кругла кнопка 34px з іконкою знака питання, підпис — у aria-label і підказці.
 */
export function HelpButton({ ws }: IHelpButtonProps) {
  const { t } = useTranslation();
  const label = useLabel();
  const lang = useAppSelector(selectLang);
  const { module, catalog } = useShellNav(ws);
  if (module) {
    const title = t('shell.helpModule', { name: label(catalog?.modules.find((m) => m.key === module)?.name) || module });
    return (
      <Link className="po-topbar__icon tb-icon tb-wide" to={routes.modulePage(module, 'help')} title={title} aria-label={title}>
        <Icon name="circle-help" size={16} />
      </Link>
    );
  }
  return (
    <a className="po-topbar__icon tb-icon tb-wide" href={websiteUrl(lang, 'platform/help/index.html')} target="_blank" rel="noopener noreferrer" title={t('shell.helpSite')} aria-label={t('shell.helpSite')}>
      <Icon name="circle-help" size={16} />
    </a>
  );
}
